import { AnimatePresence, motion } from "motion/react";
import { SyntheticEvent } from "react";
import css from "./FloatingButton.module.scss";

export type FloatingButtonProps = {
  show?: boolean;
  onClick?: (ev: SyntheticEvent) => void;
  position?: "bottom-right" | "bottom-left";
} & React.PropsWithChildren;
export function FloatingButton(props: FloatingButtonProps) {
  return (
    <AnimatePresence>
      {props.show && (
        <motion.button
          data-testid={props["data-testid"]}
          onClick={props.onClick}
          initial={{
            opacity: 0,
            right:
              (props.position ?? "bottom-right") === "bottom-right"
                ? 10
                : undefined,
            left:
              (props.position ?? "bottom-right") === "bottom-left"
                ? 10
                : undefined,
            bottom: 10,
            y: 10,
          }}
          animate={{
            opacity: 1,
            y: 0,
          }}
          exit={{
            opacity: 0,
            right:
              (props.position ?? "bottom-right") === "bottom-right"
                ? 10
                : undefined,
            left:
              (props.position ?? "bottom-right") === "bottom-left"
                ? 10
                : undefined,
            y: 10,
          }}
          className={css.FloatingButton}
        >
          {props.children}
        </motion.button>
      )}
    </AnimatePresence>
  );
}
